import Logo from "./Logo";
import HeaderNav from "./HeaderNav";

const Header = () => {
    return <HeaderNav img={<Logo/>}/>
};

export default Header;